// MES 모듈 스토어 초기화 공통 함수
// 탭 닫기, 모든 탭 닫기, 로그아웃 시 스토어 초기화에 사용

import { useMST1010_R01Store } from 'src/containers/mes/MST/MST1010_R01/Store_MST1010_R01';
import { useMST1011_R01Store } from 'src/containers/mes/MST/MST1011_R01/Store_MST1011_R01';
import { useMST1020_R01Store } from 'src/containers/mes/MST/MST1020_R01/Store_MST1020_R01';
import { useMST1030_R01Store } from 'src/containers/mes/MST/MST1030_R01/Store_MST1030_R01';
import { useMST1060_R10Store } from 'src/containers/mes/MST/MST1060_R10/Store_MST1060_R10';
import { useMST1110_R01Store } from 'src/containers/mes/MST/MST1110_R01/Store_MST1110_R01';
import { useMST2010_R01Store } from 'src/containers/mes/MST/MST2010_R01/Store_MST2010_R01';
import { useMST3010_R01Store } from 'src/containers/mes/MST/MST3010_R01/Store_MST3010_R01';
import { useMST3020_R01Store } from 'src/containers/mes/MST/MST3020_R01/Store_MST3020_R01';
import { useMST3040_R01Store } from 'src/containers/mes/MST/MST3040_R01/Store_MST3040_R01';
import { useMST4010_R01Store } from 'src/containers/mes/MST/MST4010_R01/Store_MST4010_R01';
import { useMST4030_R01Store } from 'src/containers/mes/MST/MST4030_R01/Store_MST4030_R01';
import { useMST4040_R01Store } from 'src/containers/mes/MST/MST4040_R01/Store_MST4040_R01';
import { useMST4050_R01Store } from 'src/containers/mes/MST/MST4050_R01/Store_MST4050_R01';
import { useMST4060_R01Store } from 'src/containers/mes/MST/MST4060_R01/Store_MST4060_R01';
import { useMST7020_R01Store } from 'src/containers/mes/MST/MST7020_R01/Store_MST7020_R01';

import { usePRD1010_R01Store } from 'src/containers/mes/PRD/PRD1010_R01/Store_PRD1010_R01';
import { usePRD1020_R01Store } from 'src/containers/mes/PRD/PRD1020_R01/Store_PRD1020_R01';
import { usePRD2010_R01Store } from 'src/containers/mes/PRD/PRD2010_R01/Store_PRD2010_R01';
import { usePRD2030_R01Store } from 'src/containers/mes/PRD/PRD2030_R01/Store_PRD2030_R01';
import { usePRD2040_R01Store } from 'src/containers/mes/PRD/PRD2040_R01/Store_PRD2040_R01';
import { usePRD2050_R01Store } from 'src/containers/mes/PRD/PRD2050_R01/Store_PRD2050_R01';
import { usePRD3010_R01Store } from 'src/containers/mes/PRD/PRD3010_R01/Store_PRD3010_R01';
import { usePRD3011_R01Store } from 'src/containers/mes/PRD/PRD3011_R01/Store_PRD3011_R01';
import { usePRD3012_R01Store } from 'src/containers/mes/PRD/PRD3012_R01/Store_PRD3012_R01';
import { usePRD3020_R01Store } from 'src/containers/mes/PRD/PRD3020_R01/Store_PRD3020_R01';
import { usePRD3030_R01Store } from 'src/containers/mes/PRD/PRD3030_R01/Store_PRD3030_R01';
import { usePRD3031_R01Store } from 'src/containers/mes/PRD/PRD3031_R01/Store_PRD3031_R01';
import { usePRD3040_R01Store } from 'src/containers/mes/PRD/PRD3040_R01/Store_PRD3040_R01';
import { usePRD3050_R01Store } from 'src/containers/mes/PRD/PRD3050_R01/Store_PRD3050_R01';
import { usePRD3060_R01Store } from 'src/containers/mes/PRD/PRD3060_R01/Store_PRD3060_R01';
import { usePRD4060_R01Store } from 'src/containers/mes/PRD/PRD4060_R01/Store_PRD4060_R01';
import { usePRD4010_R01Store } from 'src/containers/mes/PRD/PRD4010_R01/Store_PRD4010_R01';
import { usePRD4011_R01Store } from 'src/containers/mes/PRD/PRD4011_R01/Store_PRD4011_R01';
import { usePRD5010_R01Store } from 'src/containers/mes/PRD/PRD5010_R01/Store_PRD5010_R01';
import { usePRD5011_R01Store } from 'src/containers/mes/PRD/PRD5011_R01/Store_PRD5011_R01';
import { usePRD5020_R01Store } from 'src/containers/mes/PRD/PRD5020_R01/Store_PRD5020_R01';
import { usePRD5030_R01Store } from 'src/containers/mes/PRD/PRD5030_R01/Store_PRD5030_R01';
import {usePRD5040_R01Store} from "src/containers/mes/PRD/PRD5040_R01/Store_PRD5040_R01";
import {usePRD5050_R01Store} from "src/containers/mes/PRD/PRD5050_R01/Store_PRD5050_R01";

import { usePUR1020_R01Store } from 'src/containers/mes/PUR/PUR1020_R01/Store_PUR1020_R01';
import { usePUR1021_R01Store } from 'src/containers/mes/PUR/PUR1021_R01/Store_PUR1021_R01';
import { usePUR1030_R01Store } from 'src/containers/mes/PUR/PUR1030_R01/Store_PUR1030_R01';
import { usePUR2010_R01Store } from 'src/containers/mes/PUR/PUR2010_R01/Store_PUR2010_R01';
import { usePUR2020_R01Store } from 'src/containers/mes/PUR/PUR2020_R01/Store_PUR2020_R01';
import { usePUR1040_R01Store } from 'src/containers/mes/PUR/PUR1040_R01/Store_PUR1040_R01';
import { usePUR5010_R01Store } from 'src/containers/mes/PUR/PUR5010_R01/Store_PUR5010_R01';
import { usePUR5020_R01Store } from 'src/containers/mes/PUR/PUR5020_R01/Store_PUR5020_R01';
import { usePUR6010_R01Store } from 'src/containers/mes/PUR/PUR6010_R01/Store_PUR6010_R01';

import { useSAL1010_R01Store } from 'src/containers/mes/SAL/SAL1010_R01/Store_SAL1010_R01';
import { useSAL1011_R01Store } from 'src/containers/mes/SAL/SAL1011_R01/Store_SAL1011_R01';
import { useSAL1020_R01Store } from 'src/containers/mes/SAL/SAL1020_R01/Store_SAL1020_R01';
import { useSAL1030_R01Store } from 'src/containers/mes/SAL/SAL1030_R01/Store_SAL1030_R01';
import { useSAL2020_R01Store } from 'src/containers/mes/SAL/SAL2020_R01/Store_SAL2020_R01';
import { useSAL2030_R01Store } from 'src/containers/mes/SAL/SAL2030_R01/Store_SAL2030_R01';
import { useSAL2040_R01Store } from 'src/containers/mes/SAL/SAL2040_R01/Store_SAL2040_R01';
import { useSAL2050_R01Store } from 'src/containers/mes/SAL/SAL2050_R01/Store_SAL2050_R01';
import { useSAL2060_R01Store } from 'src/containers/mes/SAL/SAL2060_R01/Store_SAL2060_R01';
import { useSAL2070_R01Store } from 'src/containers/mes/SAL/SAL2070_R01/Store_SAL2070_R01';
import { useSAL2080_R01Store } from 'src/containers/mes/SAL/SAL2080_R01/Store_SAL2080_R01';
import { useSAL2090_R01Store } from 'src/containers/mes/SAL/SAL2090_R01/Store_SAL2090_R01';
import { useSAL3010_R01Store } from 'src/containers/mes/SAL/SAL3010_R01/Store_SAL3010_R01';
import { useSAL3050_R01Store } from 'src/containers/mes/SAL/SAL3050_R01/Store_SAL3050_R01';
import { useSAL6010_R01Store } from 'src/containers/mes/SAL/SAL6010_R01/Store_SAL6010_R01';
import { useSAL6020_R01Store } from 'src/containers/mes/SAL/SAL6020_R01/Store_SAL6020_R01';
import { useSAL6030_R01Store } from 'src/containers/mes/SAL/SAL6030_R01/Store_SAL6030_R01';

import { useSYS1010_R01Store } from 'src/containers/mes/SYS/SYS1010_R01/Store_SYS1010_R01';
import { useSYS1020_R01Store } from 'src/containers/mes/SYS/SYS1020_R01/Store_SYS1020_R01';
import { useSYS2010_R01Store } from 'src/containers/mes/SYS/SYS2010_R01/Store_SYS2010_R01';
import { useSYS2020_R01Store } from 'src/containers/mes/SYS/SYS2020_R01/Store_SYS2020_R01';
import { useSYS3010_R01Store } from 'src/containers/mes/SYS/SYS3010_R01/Store_SYS3010_R01';
import { useSYS3020_R01Store } from 'src/containers/mes/SYS/SYS3020_R01/Store_SYS3020_R01';
import { useSYS3050_R01Store } from 'src/containers/mes/SYS/SYS3050_R01/Store_SYS3050_R01';
import { useSYS3060_R01Store } from 'src/containers/mes/SYS/SYS3060_R01/Store_SYS3060_R01';
import { useSYS4010_R01Store } from 'src/containers/mes/SYS/SYS4010_R01/Store_SYS4010_R01';
import { useSYS4030_R01Store } from 'src/containers/mes/SYS/SYS4030_R01/Store_SYS4030_R01';
import { useSYS4090_R01Store } from 'src/containers/mes/SYS/SYS4090_R01/Store_SYS4090_R01';
import { useHRM2130_R01Store } from 'src/containers/mes/HRM/HRM2130_R01/Store_HRM2130_R01';
import { useHRM3130_R01Store } from 'src/containers/mes/HRM/HRM3130_R01/Store_HRM3130_R01';
import { useHRM1060_R01Store } from 'src/containers/mes/HRM/HRM1060_R01/Store_HRM1060_R01';
import { useHRM2040_R01Store } from 'src/containers/mes/HRM/HRM2040_R01/Store_HRM2040_R01';
import { useHRM3110_R01Store } from 'src/containers/mes/HRM/HRM3110_R01/Store_HRM3110_R01';
import { useHRM3040_R01Store } from 'src/containers/mes/HRM/HRM3040_R01/Store_HRM3040_R01';
import { useHRM3050_R01Store } from 'src/containers/mes/HRM/HRM3050_R01/Store_HRM3050_R01';
import { useHRM1040_R01Store } from 'src/containers/mes/HRM/HRM1040_R01/Store_HRM1040_R01';
import { useHRM1030_R01Store } from 'src/containers/mes/HRM/HRM1030_R01/Store_HRM1030_R01';
import { useHRM2120_R01Store } from 'src/containers/mes/HRM/HRM2120_R01/Store_HRM2120_R01';
import { useHRM2010_R01Store } from 'src/containers/mes/HRM/HRM2010_R01/Store_HRM2010_R01';
import { useSYS4100_R01Store } from 'src/containers/mes/SYS/SYS4100_R01/Store_SYS4100_R01';
import { useSYS4110_R01Store } from 'src/containers/mes/SYS/SYS4110_R01/Store_SYS4110_R01';
import { useSYS4120_R01Store } from 'src/containers/mes/SYS/SYS4120_R01/Store_SYS4120_R01';
import { useSYS5010_R01Store } from 'src/containers/mes/SYS/SYS5010_R01/Store_SYS5010_R01';

import { useWMS1020_R01Store } from 'src/containers/mes/WMS/WMS1020_R01/Store_WMS1020_R01';
import { useWMS1021_R01Store } from 'src/containers/mes/WMS/WMS1021_R01/Store_WMS1021_R01';
import { useWMS1022_R01Store } from 'src/containers/mes/WMS/WMS1022_R01/Store_WMS1022_R01';
import { useWMS1030_R01Store } from 'src/containers/mes/WMS/WMS1030_R01/Store_WMS1030_R01';
import { useWMS1031_R01Store } from 'src/containers/mes/WMS/WMS1031_R01/Store_WMS1031_R01';
import { useWMS1060_R01Store } from 'src/containers/mes/WMS/WMS1060_R01/Store_WMS1060_R01';
import { useWMS1100_R01Store } from 'src/containers/mes/WMS/WMS1100_R01/Store_WMS1100_R01';
import { useWMS1101_R01Store } from 'src/containers/mes/WMS/WMS1101_R01/Store_WMS1101_R01';
// WMS1120_R01은 TQC3020_R01 전환 후 비활성 상태로 파일만 유지한다.
// import { useWMS1120_R01Store } from 'src/containers/mes/WMS/WMS1120_R01/Store_WMS1120_R01';
import { useWMS1130_R01Store } from 'src/containers/mes/WMS/WMS1130_R01/Store_WMS1130_R01';
import { useWMS1131_R01Store } from 'src/containers/mes/WMS/WMS1131_R01/Store_WMS1131_R01';
import { useWMS1140_R01Store } from 'src/containers/mes/WMS/WMS1140_R01/Store_WMS1140_R01';
import { useWMS1141_R01Store } from 'src/containers/mes/WMS/WMS1141_R01/Store_WMS1141_R01';
import { useWMS2010_R01Store } from 'src/containers/mes/WMS/WMS2010_R01/Store_WMS2010_R01';
import { useWMS2011_R01Store } from 'src/containers/mes/WMS/WMS2011_R01/Store_WMS2011_R01';
import { useWMS2020_R01Store } from 'src/containers/mes/WMS/WMS2020_R01/Store_WMS2020_R01';
import { useWMS2021_R01Store } from 'src/containers/mes/WMS/WMS2021_R01/Store_WMS2021_R01';
import { useWMS2040_R01Store } from 'src/containers/mes/WMS/WMS2040_R01/Store_WMS2040_R01';
import { useWMS2060_R01Store } from 'src/containers/mes/WMS/WMS2060_R01/Store_WMS2060_R01';
import { useWMS2061_R01Store } from 'src/containers/mes/WMS/WMS2061_R01/Store_WMS2061_R01';
import { useWMS2090_R01Store } from 'src/containers/mes/WMS/WMS2090_R01/Store_WMS2090_R01';
import { useWMS2091_R01Store } from 'src/containers/mes/WMS/WMS2091_R01/Store_WMS2091_R01';

import { useTQC2020_R01Store } from 'src/containers/mes/TQC/TQC2020_R01/Store_TQC2020_R01';
import { useTQC1020_R01Store } from 'src/containers/mes/TQC/TQC1020_R01/Store_TQC1020_R01';
import { useTQC1040_R01Store } from 'src/containers/mes/TQC/TQC1040_R01/Store_TQC1040_R01';
import { useTQC1050_R01Store } from 'src/containers/mes/TQC/TQC1050_R01/Store_TQC1050_R01';
import { useTQC1060_R01Store } from 'src/containers/mes/TQC/TQC1060_R01/Store_TQC1060_R01';
import { useTQC2010_R01Store } from 'src/containers/mes/TQC/TQC2010_R01/Store_TQC2010_R01';
import { useTQC2011_R01Store } from 'src/containers/mes/TQC/TQC2011_R01/Store_TQC2011_R01';
import { useTQC2050_R01Store } from 'src/containers/mes/TQC/TQC2050_R01/Store_TQC2050_R01';
import { useTQC2060_R01Store } from 'src/containers/mes/TQC/TQC2060_R01/Store_TQC2060_R01';
import { useTQC2070_R01Store } from 'src/containers/mes/TQC/TQC2070_R01/Store_TQC2070_R01';
import { useTQC2080_R01Store } from 'src/containers/mes/TQC/TQC2080_R01/Store_TQC2080_R01';
import { useTQC2090_R01Store } from 'src/containers/mes/TQC/TQC2090_R01/Store_TQC2090_R01';
import { useTQC3010_R01Store } from 'src/containers/mes/TQC/TQC3010_R01/Store_TQC3010_R01';
import { useTQC3020_R01Store } from 'src/containers/mes/TQC/TQC3020_R01/Store_TQC3020_R01';
import { useTQC5010_R01Store } from 'src/containers/mes/TQC/TQC5010_R01/Store_TQC5010_R01';
import { useTQC5020_R01Store } from 'src/containers/mes/TQC/TQC5020_R01/Store_TQC5020_R01';

import { useEQM1010_R01Store } from 'src/containers/mes/EQM/EQM1010_R01/Store_EQM1010_R01';
import { useEQM1011_R01Store } from 'src/containers/mes/EQM/EQM1011_R01/Store_EQM1011_R01';
import { useEQM1020_R01Store } from 'src/containers/mes/EQM/EQM1020_R01/Store_EQM1020_R01';
import { useEQM2010_R01Store } from 'src/containers/mes/EQM/EQM2010_R01/Store_EQM2010_R01';
import { useEQM2020_R01Store } from 'src/containers/mes/EQM/EQM2020_R01/Store_EQM2020_R01';
import { useEQM1030_R01Store } from 'src/containers/mes/EQM/EQM1030_R01/Store_EQM1030_R01';
import { useEQM2040_R01Store } from 'src/containers/mes/EQM/EQM2040_R01/Store_EQM2040_R01';
import { useEQM2050_R01Store } from 'src/containers/mes/EQM/EQM2050_R01/Store_EQM2050_R01';
import { useEQM2060_R01Store } from 'src/containers/mes/EQM/EQM2060_R01/Store_EQM2060_R01';
import { useEQM2070_R01Store } from 'src/containers/mes/EQM/EQM2070_R01/Store_EQM2070_R01';
import { useTQC2100_R01Store } from 'src/containers/mes/TQC/TQC2100_R01/Store_TQC2100_R01';
import { useEQM2080_R01Store } from 'src/containers/mes/EQM/EQM2080_R01/Store_EQM2080_R01';
import { useEQM3010_R01Store } from 'src/containers/mes/EQM/EQM3010_R01/Store_EQM3010_R01';
import { useEQM3020_R01Store } from 'src/containers/mes/EQM/EQM3020_R01/Store_EQM3020_R01';
import { useEQM4010_R01Store } from 'src/containers/mes/EQM/EQM4010_R01/Store_EQM4010_R01';
import { useSAL2100_R01Store } from 'src/containers/mes/SAL/SAL2100_R01/Store_SAL2100_R01';
import { useSAL2110_R01Store } from 'src/containers/mes/SAL/SAL2110_R01/Store_SAL2110_R01';


// 스토어 초기화 맵
const initMap: Record<string, () => void> = {
		// MST (기준정보 관리)
		'MST1010_R01': () => useMST1010_R01Store.getState().initData(),
		'MST1020_R01': () => useMST1020_R01Store.getState().initData(),
		'MST1030_R01': () => useMST1030_R01Store.getState().initData(),
		'MST1060_R10': () => useMST1060_R10Store.getState().initData(),
		'MST1011_R01': () => useMST1011_R01Store.getState().initData(),
		'MST1110_R01': () => useMST1110_R01Store.getState().initData(),
		'MST2010_R01': () => useMST2010_R01Store.getState().initData(),
		'MST3010_R01': () => useMST3010_R01Store.getState().initData(),
		'MST3020_R01': () => useMST3020_R01Store.getState().initData(),
		'MST3040_R01': () => useMST3040_R01Store.getState().initData(),
		'MST4010_R01': () => useMST4010_R01Store.getState().initData(),
		'MST4030_R01': () => useMST4030_R01Store.getState().initData(),
		'MST4040_R01': () => useMST4040_R01Store.getState().initData(),
		'MST4050_R01': () => useMST4050_R01Store.getState().initData(),
		'MST4060_R01': () => useMST4060_R01Store.getState().initData(),
		'MST7020_R01': () => useMST7020_R01Store.getState().initData(),

		// PRD (생산 관리)
		'PRD1010_R01': () => usePRD1010_R01Store.getState().initData(),
		'PRD1020_R01': () => usePRD1020_R01Store.getState().initData(),
		'PRD2010_R01': () => usePRD2010_R01Store.getState().initData(),
		'PRD2030_R01': () => usePRD2030_R01Store.getState().initData(),
		'PRD2040_R01': () => usePRD2040_R01Store.getState().initData(),
		'PRD2050_R01': () => usePRD2050_R01Store.getState().initData(),
		'PRD3010_R01': () => usePRD3010_R01Store.getState().initData(),
		'PRD3011_R01': () => usePRD3011_R01Store.getState().initData(),
		'PRD3012_R01': () => usePRD3012_R01Store.getState().initData(),
		'PRD3020_R01': () => usePRD3020_R01Store.getState().initData(),
		'PRD3030_R01': () => usePRD3030_R01Store.getState().initData(),
		'PRD3031_R01': () => usePRD3031_R01Store.getState().initData(),
		'PRD3040_R01': () => usePRD3040_R01Store.getState().initData(),
		'PRD3050_R01': () => usePRD3050_R01Store.getState().initData(),
		'PRD3060_R01': () => usePRD3060_R01Store.getState().initData(),
		'PRD4060_R01': () => usePRD4060_R01Store.getState().initData(),
		'PRD4010_R01': () => usePRD4010_R01Store.getState().initData(),
		'PRD4011_R01': () => usePRD4011_R01Store.getState().initData(),
		'PRD5010_R01': () => usePRD5010_R01Store.getState().initData(),
		'PRD5011_R01': () => usePRD5011_R01Store.getState().initData(),
		'PRD5020_R01': () => usePRD5020_R01Store.getState().initData(),
		'PRD5030_R01': () => usePRD5030_R01Store.getState().initData(),
        'PRD5040_R01': () => usePRD5040_R01Store.getState().initData(),
        'PRD5050_R01': () => usePRD5050_R01Store.getState().initData(),

		// PUR (구매 관리)
		'PUR1020_R01': () => usePUR1020_R01Store.getState().initData(),
		'PUR1021_R01': () => usePUR1021_R01Store.getState().initData(),
		'PUR1030_R01': () => usePUR1030_R01Store.getState().initData(),
		'PUR2010_R01': () => usePUR2010_R01Store.getState().initData(),
		'PUR2020_R01': () => usePUR2020_R01Store.getState().initData(),
		'PUR1040_R01': () => usePUR1040_R01Store.getState().initData(),
		'PUR5010_R01': () => usePUR5010_R01Store.getState().initData(),
		'PUR5020_R01': () => usePUR5020_R01Store.getState().initData(),
		'PUR6010_R01': () => usePUR6010_R01Store.getState().initData(),

		// SAL (영업 관리)
		'SAL1010_R01': () => useSAL1010_R01Store.getState().initData(),
		'SAL1011_R01': () => useSAL1011_R01Store.getState().initData(),
		'SAL1020_R01': () => useSAL1020_R01Store.getState().initData(),
		'SAL1030_R01': () => useSAL1030_R01Store.getState().initData(),
		'SAL2020_R01': () => useSAL2020_R01Store.getState().initData(),
		'SAL2030_R01': () => useSAL2030_R01Store.getState().initData(),
		'SAL2040_R01': () => useSAL2040_R01Store.getState().initData(),
		'SAL2050_R01': () => useSAL2050_R01Store.getState().initData(),
		'SAL2060_R01': () => useSAL2060_R01Store.getState().initData(),
		'SAL2070_R01': () => useSAL2070_R01Store.getState().initData(),
		'SAL2080_R01': () => useSAL2080_R01Store.getState().initData(),
		'SAL2090_R01': () => useSAL2090_R01Store.getState().initData(),
		'SAL2100_R01': () => useSAL2100_R01Store.getState().initData(),
		'SAL2110_R01': () => useSAL2110_R01Store.getState().initData(),
		'SAL3010_R01': () => useSAL3010_R01Store.getState().initData(),
		'SAL3050_R01': () => useSAL3050_R01Store.getState().initData(),
		'SAL6010_R01': () => useSAL6010_R01Store.getState().initData(),
		'SAL6020_R01': () => useSAL6020_R01Store.getState().initData(),
		'SAL6030_R01': () => useSAL6030_R01Store.getState().initData(),

		// SYS (시스템 관리)
		'SYS1010_R01': () => useSYS1010_R01Store.getState().initData(),
		'SYS1020_R01': () => useSYS1020_R01Store.getState().initData(),
		'SYS2010_R01': () => useSYS2010_R01Store.getState().initData(),
		'SYS2020_R01': () => useSYS2020_R01Store.getState().initData(),
		'SYS3010_R01': () => useSYS3010_R01Store.getState().initData(),
		'SYS3020_R01': () => useSYS3020_R01Store.getState().initData(),
		'SYS3050_R01': () => useSYS3050_R01Store.getState().initData(),
		'SYS3060_R01': () => useSYS3060_R01Store.getState().initData(),
		'SYS4010_R01': () => useSYS4010_R01Store.getState().initData(),
		'SYS4030_R01': () => useSYS4030_R01Store.getState().initData(),
		'SYS4090_R01': () => useSYS4090_R01Store.getState().initData(),
		'HRM2130_R01': () => useHRM2130_R01Store.getState().initData(),
		'HRM3130_R01': () => useHRM3130_R01Store.getState().initData(),
		'HRM1060_R01': () => useHRM1060_R01Store.getState().initData(),
		'HRM2040_R01': () => useHRM2040_R01Store.getState().initData(),
		'HRM3110_R01': () => useHRM3110_R01Store.getState().initData(),
		'HRM3040_R01': () => useHRM3040_R01Store.getState().initData(),
		'HRM3050_R01': () => useHRM3050_R01Store.getState().initData(),
		'HRM1040_R01': () => useHRM1040_R01Store.getState().initData(),
		'HRM1030_R01': () => useHRM1030_R01Store.getState().initData(),
		'HRM2120_R01': () => useHRM2120_R01Store.getState().initData(),
		'HRM2010_R01': () => useHRM2010_R01Store.getState().initData(),
		'SYS4100_R01': () => useSYS4100_R01Store.getState().initData(),
		'SYS4110_R01': () => useSYS4110_R01Store.getState().initData(),
		'SYS4120_R01': () => useSYS4120_R01Store.getState().initData(),
		'SYS5010_R01': () => useSYS5010_R01Store.getState().initData(),

		// WMS (창고 관리)
		'WMS1020_R01': () => useWMS1020_R01Store.getState().initData(),
		'WMS1021_R01': () => useWMS1021_R01Store.getState().initData(),
		'WMS1022_R01': () => useWMS1022_R01Store.getState().initData(),
		'WMS1030_R01': () => useWMS1030_R01Store.getState().initData(),
		'WMS1031_R01': () => useWMS1031_R01Store.getState().initData(),
		'WMS1060_R01': () => useWMS1060_R01Store.getState().initData(),
		'WMS1100_R01': () => useWMS1100_R01Store.getState().initData(),
		'WMS1101_R01': () => useWMS1101_R01Store.getState().initData(),
		// 'WMS1120_R01': () => useWMS1120_R01Store.getState().initData(),
		'WMS1130_R01': () => useWMS1130_R01Store.getState().initData(),
		'WMS1131_R01': () => useWMS1131_R01Store.getState().initData(),
		'WMS1140_R01': () => useWMS1140_R01Store.getState().initData(),
		'WMS1141_R01': () => useWMS1141_R01Store.getState().initData(),
		'WMS2010_R01': () => useWMS2010_R01Store.getState().initData(),
		'WMS2011_R01': () => useWMS2011_R01Store.getState().initData(),
		'WMS2020_R01': () => useWMS2020_R01Store.getState().initData(),
		'WMS2021_R01': () => useWMS2021_R01Store.getState().initData(),
		'WMS2040_R01': () => useWMS2040_R01Store.getState().initData(),
		'WMS2060_R01': () => useWMS2060_R01Store.getState().initData(),
		'WMS2061_R01': () => useWMS2061_R01Store.getState().initData(),
		'WMS2090_R01': () => useWMS2090_R01Store.getState().initData(),
		'WMS2091_R01': () => useWMS2091_R01Store.getState().initData(),

		// TQC (품질 관리)
		'TQC1020_R01': () => useTQC1020_R01Store.getState().initData(),
		'TQC1040_R01': () => useTQC1040_R01Store.getState().initData(),
		'TQC1050_R01': () => useTQC1050_R01Store.getState().initData(),
		'TQC1060_R01': () => useTQC1060_R01Store.getState().initData(),
		'TQC2010_R01': () => useTQC2010_R01Store.getState().initData(),
		'TQC2011_R01': () => useTQC2011_R01Store.getState().initData(),
		'TQC2020_R01': () => useTQC2020_R01Store.getState().initData(),
		'TQC2050_R01': () => useTQC2050_R01Store.getState().initData(),
		'TQC2060_R01': () => useTQC2060_R01Store.getState().initData(),
		'TQC2070_R01': () => useTQC2070_R01Store.getState().initData(),
		'TQC2080_R01': () => useTQC2080_R01Store.getState().initData(),
		'TQC2090_R01': () => useTQC2090_R01Store.getState().initData(),
		'TQC3010_R01': () => useTQC3010_R01Store.getState().initData(),
		'TQC3020_R01': () => useTQC3020_R01Store.getState().initData(),
		'TQC5010_R01': () => useTQC5010_R01Store.getState().initData(),
		'TQC5020_R01': () => useTQC5020_R01Store.getState().initData(),

		// EQM (설비 관리)
		'EQM1010_R01': () => useEQM1010_R01Store.getState().initData(),
		'EQM1011_R01': () => useEQM1011_R01Store.getState().initData(),
		'EQM1020_R01': () => useEQM1020_R01Store.getState().initData(),
		'EQM2010_R01': () => useEQM2010_R01Store.getState().initData(),
		'EQM2020_R01': () => useEQM2020_R01Store.getState().initData(),
		'EQM1030_R01': () => useEQM1030_R01Store.getState().initData(),
		'EQM2040_R01': () => useEQM2040_R01Store.getState().initData(),
		'EQM2050_R01': () => useEQM2050_R01Store.getState().initData(),
		'EQM2060_R01': () => useEQM2060_R01Store.getState().initData(),
		'EQM2070_R01': () => useEQM2070_R01Store.getState().initData(),
		'TQC2100_R01': () => useTQC2100_R01Store.getState().initData(),
		'EQM2080_R01': () => useEQM2080_R01Store.getState().initData(),
		'EQM3010_R01': () => useEQM3010_R01Store.getState().initData(),
		'EQM3020_R01': () => useEQM3020_R01Store.getState().initData(),
		'EQM4010_R01': () => useEQM4010_R01Store.getState().initData(),
	};

/**
 * 탭 key에 따라 해당 화면의 스토어를 초기화하는 함수
 * @param key 탭의 고유 키 (예: 'MST1010_R01')
 * @description
 * - 탭을 닫을 때 해당 화면의 상태를 초기화하여 메모리 누수 방지
 * - useUiuxStore의 closeAllTabs, closeOtherTabs, closeRightTabs에서 사용
 * - tabUtils의 handleExitClick에서도 사용
 */
export const initializeTabStore = (key: string): void => {
	// 해당 key에 매핑된 초기화 함수가 있으면 실행
	const initFn = initMap[key];
	if (initFn) {
		try {
			initFn();
		} catch (error) {
			console.error(`[storeInitializer] ${key} 스토어 초기화 중 오류 발생:`, error);
		}
	}
};

/**
 * 등록된 모든 스토어 key 목록을 반환
 * @returns 모든 스토어 key 배열
 */
export const getAllStoreKeys = (): string[] => {
	return Object.keys(initMap);
};

/**
 * 모든 스토어를 초기화하는 함수 (로그아웃 시 사용)
 * @description
 * - resetAllStores에서 사용
 * - 등록된 모든 스토어의 initData()를 호출
 */
export const initializeAllStores = (): void => {
	const allKeys = getAllStoreKeys();
	allKeys.forEach(key => {
		initializeTabStore(key);
	});
};
